/** Export GPX 1.1 del percorso (per OsmAnd, Komoot, orologi GPS…). */

import type { LatLng } from './geo';

function esc(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function buildGpx(name: string, coords: LatLng[], timeMs?: number): string {
  const meta = timeMs ? `\n    <time>${new Date(timeMs).toISOString()}</time>` : '';
  const pts = coords
    .map((c) => `      <trkpt lat="${c.lat.toFixed(6)}" lon="${c.lng.toFixed(6)}"/>`)
    .join('\n');
  return `<?xml version="1.0" encoding="UTF-8"?>
<gpx version="1.1" creator="ShadowRoute" xmlns="http://www.topografix.com/GPX/1/1">
  <metadata>
    <name>${esc(name)}</name>${meta}
  </metadata>
  <trk>
    <name>${esc(name)}</name>
    <trkseg>
${pts}
    </trkseg>
  </trk>
</gpx>
`;
}
